import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private url = `${environment.reportApiUrl}/report`;

  constructor(private api: ApiService) {}

  // getReportRequests() {
  //   return this.api.get(`${this.url}/report-requests`);
  // }

  getAdjustment(reportType: number, date: string, subId: number) {
    return this.api.get(
      `${this.url}/get-adjustment?reportType=${reportType}&date=${date}&subId=${subId}`
    );
  }

  saveAdjustment(data) {
    return this.api.post(`${this.url}/save-adjustment`, data);
  }

  cancelAdjustment(reportType: number, date: string, subId: number) {
    return this.api.get(
      `${this.url}/cancel-adjustment?reportType=${reportType}&date=${date}&subId=${subId}`
    );
  }
}
